/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {internalProcessNotificationPreferenceUpdatedEventSync} from '../api'

export const useMutationInternalProcessNotificationPreferenceUpdatedEventSync = createReactQueryMutationHook('internalProcessNotificationPreferenceUpdatedEventSync', internalProcessNotificationPreferenceUpdatedEventSync)
